// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"b6738707","484":"1bef058b"}[chunkId] + ".chunk.js";
};